import React, { useRef } from 'react';
import PostList from '../../Posts/PostList';
import { useSelector } from 'react-redux';
import { selectCurrentPostIsLoading, selectCurrentPostRelated } from 'store/slices/BlogSlice';
import { useAnimation } from 'hooks/useAnimation';

const PostRelated = () => {
    const { title, posts } = useSelector(selectCurrentPostRelated);
    const loading = useSelector(selectCurrentPostIsLoading);


    const container = useRef();
    useAnimation({
        items: ['.post-related h2'],
        container,
        dependencies: [loading],
    })
    if (!posts) return null
    return (
        <section ref={container} className='inner-container post-related'>
            <h2>{title}</h2>
            <PostList posts={posts.data} />
        </section>
    );
};

export default PostRelated;
